module.exports = __webpack_public_path__ + "img/logo.909d812e.png";